import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useUserContext from 'Context/UserContext';
import {
  BaseAccountInfo,
} from 'Views/Page/Content/Modal/Layouts/FinancialInstitutionConnectionLayout/Layout/AccountLayout/BaseAccountInfo';

export const BalanceSheetAccountLayout = () => {
  const { isAgent } = useUserContext();

  return (
    <>
      <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
        <BaseAccountInfo />
        <MetaControlField attr={'ownerClientId'} />
        <MetaControlField attr={'owner'} />

        <MetaLayoutRemainingFields expanded={isAgent} noAccordion />
      </FDStack>
    </>
  );
};
